import { createAsyncThunk } from "@reduxjs/toolkit";
import { getExecutionLogDetailsThunk } from "./getExecutionLogDetailsThunk";
import { setExecutionLogData } from "../executionLogSlice";
import {
  cloudChiprApi,
  PostV3UsersMeExecutionLogsApiArg,
} from "../../../services/cloudchipr.api";
import { RootState } from "../../store";
import { executionLogStateSelector } from "../selectors/executionLogStateSelector";
import { executionLogPayloadDatesSelector } from "../selectors/executionLogPayloadDatesSelector";

export const getExecutionLogThunkFixedCacheKey =
  "postV3UsersMeExecutionLogs-fixed-cache-key";

export const getExecutionLogThunk = createAsyncThunk(
  "executionLog/getExecutionLog",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;
    const { filters, pagination } = executionLogStateSelector(state);
    const dates = executionLogPayloadDatesSelector(state);

    type Body = PostV3UsersMeExecutionLogsApiArg["body"];

    const requestFilters: Body = {
      ...pagination,
      ...dates,
      search: filters?.search || undefined,
      account_ids: checkByLength(filters?.accountIds),
      executed_by: checkByLength(filters?.executedBy),
      execution_log_ids: checkByLength(filters?.executionLogIds),
      source: checkByLength(filters?.source) as Body["source"],
      action: checkByLength(filters?.action) as Body["action"],
    };

    if (filters?.state?.length && filters?.state?.length === 1) {
      requestFilters.state = filters?.state?.at(0);
    }

    dispatch(getExecutionLogDetailsThunk(requestFilters));

    const response = await dispatch(
      cloudChiprApi.endpoints.postV3UsersMeExecutionLogs.initiate(
        { body: requestFilters },
        { fixedCacheKey: getExecutionLogThunkFixedCacheKey },
      ),
    );

    if ("data" in response) {
      response.data && dispatch(setExecutionLogData(response.data));
    }
  },
);

const checkByLength = (data?: string[] | null) => {
  return data?.length ? data : null;
};
